
var E=window.EGO||{},B0=E.basics||{products:[]},guest=false,FMT=null;
try{FMT=new Intl.NumberFormat(document.documentElement.lang||"es",{style:"currency",currency:E.cur||"USD"})}catch(e){}
function $(i){return document.getElementById(i)}
function money(n){return FMT?FMT.format(n):"$"+Number(n).toFixed(2)}
function esc(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]})}
function slug(t){return t.toLowerCase().replace(/[^a-z0-9]+/g,"-")}
function msg(id,t,ok){var e=$(id);if(!e)return;e.textContent=t;e.className="msg"+(ok?" ok":"")}
var COLORS=["#0d120f","#14392a","#1d2a22","#7a1424","#050605"];
var PRODUCTS=(B0.products||[]).map(function(p,i){p.c=COLORS[i%COLORS.length];return p});
function prod(id){return PRODUCTS.filter(function(x){return x.id==id})[0]}
function swStyle(p){return p.img?"background:#050605 url("+esc(p.img)+") center/cover":"background:"+p.c}
function sizesOf(p){return (p.variants||[]).filter(function(v){return v.t!=="Default Title"})}
function defVar(p){var vs=sizesOf(p),a=vs.filter(function(v){return v.a})[0];if(vs.length)return (a||vs[0]).id;return p.variants&&p.variants[0]?p.variants[0].id:null}
function lc(c){var n=parseInt(c.slice(1),16),r=n>>16,g=n>>8&255,b=n&255;return (r*299+g*587+b*114)/1000>150?"#000":"#efe9dc"}
var tabsOpen=[],active="main",sizes={},ck={id:0,v:null};
function renderShop(){
  $("shop").innerHTML=PRODUCTS.length?PRODUCTS.map(function(p){return '<div class="item click" data-o="'+p.id+'"><div class="sw" style="'+swStyle(p)+'"></div><div class="n"><b><button class="lnk" data-o="'+p.id+'">'+esc(p.n)+'</button></b><span>'+esc(p.d)+'</span></div><div class="price">'+money(p.p)+'</div><button class="p" data-b="'+p.id+'">Comprar</button></div>'}).join(""):'<p class="note" style="margin:12px 0">Aún no hay básicos. Añade productos a la colección "basicos" en tu panel de Shopify.</p>';
}
function openTab(id){if(tabsOpen.indexOf(id)<0){tabsOpen.push(id);sizes[id]=defVar(prod(id))}active=id;renderTabs()}
function closeTab(id){var i=tabsOpen.indexOf(id);if(i<0)return;tabsOpen.splice(i,1);if(active==id)active=tabsOpen[i]||tabsOpen[i-1]||"main";renderTabs()}
function renderTabs(){
  var h='<span class="bt'+(active=="main"?" on":"")+'"><button data-t="main">Tienda</button></span>';
  tabsOpen.forEach(function(id){var p=prod(id);h+='<span class="bt'+(active==id?" on":"")+'"><button data-t="'+id+'">'+esc(p.n)+'</button><button class="x" data-c="'+id+'" aria-label="Cerrar pestaña '+esc(p.n)+'">x</button></span>'});
  $("tabs2").innerHTML=h;
  $("pgmain").classList.toggle("hide",active!="main");$("pgtab").classList.toggle("hide",active=="main");
  $("url").textContent="ego://basicos"+(active=="main"?"":"/"+slug(prod(active).n));
  $("tk").textContent=active=="main"?"Ego - Tienda":"Ego - "+prod(active).n;
  if(active!="main")renderDetail(active);
}
function renderDetail(id){
  var p=prod(id),vs=sizesOf(p);
  $("pgtab").innerHTML='<div class="det"><div class="big-sw" style="'+swStyle(p)+'">'+(p.img?'':'<span class="glow" style="width:56%"><span class="lg" style="--lgc:'+lc(p.c)+'"></span></span>')+'</div><div class="info"><h1 class="dh">'+esc(p.n)+'</h1><p class="sub">'+esc(p.d)+'</p><div class="dp">'+money(p.p)+'</div>'
  +(vs.length?'<div class="lbl">Talla</div><div class="sizes">'+vs.map(function(v){return '<button data-s="'+v.id+'" aria-pressed="'+(sizes[id]==v.id)+'"'+(v.a?'':' disabled')+'>'+esc(v.t)+'</button>'}).join("")+'</div>':'')
  +'<div class="row"><button class="p" data-b="'+id+'" data-v="'+sizes[id]+'">Comprar</button><button data-c="'+id+'">Cerrar pestaña</button></div></div></div>';
}
function buy(id,v){
  var p=prod(id);ck={id:id,v:(v&&v!="null"&&v!="undefined")?+v:defVar(p)};
  renderCk();$("ov").classList.remove("hide");
  var f=$("ov").querySelector("button:not([disabled])");if(f)f.focus();
}
function renderCk(){
  var p=prod(ck.id),vs=sizesOf(p),h='';
  h+='<div class="item" style="padding:0 0 10px"><div class="sw" style="'+swStyle(p)+'"></div><div class="n"><b>'+esc(p.n)+'</b><span>'+esc(p.d)+'</span></div><div class="price">'+money(p.p)+'</div></div>';
  if(vs.length)h+='<div class="lbl">Talla</div><div class="sizes">'+vs.map(function(v){return '<button data-ks="'+v.id+'" aria-pressed="'+(ck.v==v.id)+'"'+(v.a?'':' disabled')+'>'+esc(v.t)+'</button>'}).join("")+'</div>';
  h+='<p class="note" style="margin:14px 0 0">Seguirás al pago seguro de Shopify, donde eliges tarjeta, PayPal, Apple Pay o Google Pay. Puedes pagar como invitado.</p><p class="msg" id="ckMsg" role="alert"></p><div class="row"><button class="p" id="ckPay">Ir al pago</button><button id="ckCancel">Cancelar</button></div>';
  $("ck").innerHTML=h;
}
function pay(){
  if(!ck.v)return msg("ckMsg","Elige una talla disponible.");
  var b=$("ckPay");b.disabled=true;msg("ckMsg","Preparando el pago...",true);
  fetch("/cart/clear.js",{method:"POST"}).then(function(){
    return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:ck.v,quantity:1}]})});
  }).then(function(r){if(!r.ok)throw new Error("add");return r.json()}).then(function(){window.location.href="/checkout"}).catch(function(){b.disabled=false;msg("ckMsg","No se pudo preparar el pago. Inténtalo de nuevo.")});
}
function closeCk(){$("ov").classList.add("hide");$("ck").innerHTML=""}
function render(){
  var u=E.customer;
  $("auth").classList.toggle("hide",!!u||guest);$("acct").classList.toggle("hide",!u);$("top").classList.toggle("hide",!u);
  if(u){$("who").textContent=u;$("bal").textContent=u}
  renderShop();
}
function tick(){$("clk").textContent=new Date().toLocaleTimeString("es",{hour:"2-digit",minute:"2-digit"})}
$("guest").onclick=function(){guest=true;render()};
$("ov").addEventListener("click",function(e){
  var t=e.target;
  if(t.id=="ov"||t.closest("#ckX")||t.closest("#ckCancel"))return closeCk();
  var z=t.closest("[data-ks]");
  if(z&&!z.disabled){ck.v=+z.getAttribute("data-ks");Array.prototype.forEach.call($("ov").querySelectorAll("[data-ks]"),function(b){b.setAttribute("aria-pressed",b===z)})}
  if(t.closest("#ckPay"))pay();
});
document.addEventListener("keydown",function(e){if(e.key=="Escape"&&!$("ov").classList.contains("hide"))closeCk()});
document.addEventListener("click",function(e){
  var t=e.target.closest?e.target:e.target.parentElement;if(!t)return;
  var B=t.closest("[data-b]"),C=t.closest("[data-c]"),S=t.closest("[data-s]"),X=t.closest("[data-t]"),O=t.closest("[data-o]");
  if(B)buy(+B.getAttribute("data-b"),B.getAttribute("data-v"));
  else if(C)closeTab(+C.getAttribute("data-c"));
  else if(S&&!S.disabled){sizes[active]=+S.getAttribute("data-s");renderDetail(active)}
  else if(X){var v=X.getAttribute("data-t");active=v=="main"?"main":+v;renderTabs()}
  else if(O)openTab(+O.getAttribute("data-o"));
});
var zTop=6,narrow=window.matchMedia("(max-width:719px)"),dragW=null,wins=[],dw={},barEl=document.querySelector(".bar"),trayEl=document.querySelector(".tray");
var RZ='<div class="rz" data-r="n"></div><div class="rz" data-r="s"></div><div class="rz" data-r="e"></div><div class="rz" data-r="w"></div><div class="rz" data-r="ne"></div><div class="rz" data-r="nw"></div><div class="rz" data-r="se"></div><div class="rz" data-r="sw"></div>';
function bump(W){W.el.style.zIndex=++zTop}
function makeWin(el,task,o){
  var W={el:el,task:task,x:o.x,y:o.y,w:o.w,h:o.h,max:false,min:false,closed:false,d:null},bM=el.querySelector(".wMax"),tbar=el.querySelector(".tb");
  W.apply=function(){
    var m=W.max||narrow.matches;
    el.classList.toggle("max",m);el.classList.toggle("min",W.min);el.classList.toggle("closed",W.closed);
    if(!m){el.style.left=W.x+"px";el.style.top=W.y+"px";el.style.width=W.w+"px";el.style.height=W.h+"px"}
    task.classList.toggle("hide",W.closed);task.classList.toggle("off",W.min);
    bM.textContent=W.max&&!narrow.matches?"\u2750":"\u25A1";bM.setAttribute("aria-label",W.max?"Restaurar":"Maximizar");
  };
  W.clamp=function(){var vw=window.innerWidth,vh=window.innerHeight-38;W.w=Math.min(W.w,vw);W.h=Math.min(W.h,vh);W.x=Math.min(Math.max(W.x,100-W.w),vw-100);W.y=Math.min(Math.max(W.y,0),vh-30)};
  W.open=function(){W.closed=false;W.min=false;bump(W);W.apply()};
  function start(e,mode){if(W.max||narrow.matches||e.button>0)return;W.d={mode:mode,sx:e.clientX,sy:e.clientY,x:W.x,y:W.y,w:W.w,h:W.h};dragW=W;e.preventDefault();document.body.style.userSelect="none"}
  el.querySelector(".wMin").onclick=function(){W.min=true;W.apply()};
  bM.onclick=function(){if(narrow.matches)return;W.max=!W.max;W.apply()};
  el.querySelector(".wCls").onclick=function(){W.closed=true;W.apply()};
  task.onclick=function(){if(W.min){W.open()}else{W.min=true;W.apply()}};
  tbar.addEventListener("dblclick",function(e){if(e.target.closest("button")||narrow.matches)return;W.max=!W.max;W.apply()});
  tbar.addEventListener("pointerdown",function(e){if(e.target.closest("button"))return;start(e,"move")});
  el.addEventListener("pointerdown",function(e){bump(W);var r=e.target.getAttribute&&e.target.getAttribute("data-r");if(r)start(e,r)});
  wins.push(W);W.apply();return W;
}
window.addEventListener("pointermove",function(e){
  var W=dragW;if(!W)return;
  var d=W.d,dx=e.clientX-d.sx,dy=e.clientY-d.sy,m=d.mode,x=d.x,y=d.y,w=d.w,h=d.h;
  if(m=="move"){x+=dx;y+=dy}
  else{
    if(m.indexOf("e")>=0)w=Math.max(320,d.w+dx);
    if(m.indexOf("s")>=0)h=Math.max(260,d.h+dy);
    if(m.indexOf("w")>=0){w=Math.max(320,d.w-dx);x=d.x+d.w-w}
    if(m.indexOf("n")>=0){h=Math.max(260,d.h-dy);y=d.y+d.h-h}
  }
  W.x=x;W.y=y;W.w=w;W.h=h;W.clamp();W.apply();
});
function endDrag(){dragW=null;document.body.style.userSelect=""}
window.addEventListener("pointerup",endDrag);window.addEventListener("pointercancel",endDrag);
window.addEventListener("resize",function(){wins.forEach(function(W){W.clamp();W.apply()})});
var vw0=window.innerWidth,vh0=window.innerHeight-38,mw=Math.min(760,vw0-20),mh=Math.min(660,vh0-28);
var main=makeWin($("win"),$("tk"),{x:Math.round((vw0-mw)/2),y:Math.max(8,Math.round((vh0-mh)/3)),w:mw,h:mh});
main.closed=true;main.apply();
$("dIcon")._open=function(){main.open()};
var DROPS=(E.drops||[]).filter(function(d){return d.title}).map(function(d){
  return {n:d.title,d:d.desc,it:(d.products||[]).map(function(p,i){return [p.n,p.d,COLORS[i%COLORS.length],p.img,(p.img?[p.img]:[]).concat(p.imgs||[])]})};
});
function dropHTML(d,slug){
  var rows=d.it.map(function(x){return '<div class="item"><div class="sw" style="'+(x[3]?'background:#050605 url('+esc(x[3])+') center/cover':'background:'+x[2])+'"></div><div class="n"><b>'+esc(x[0])+'</b><span>'+esc(x[1])+'</span></div></div>'}).join("");
  var imgs=[];d.it.forEach(function(x){x[4].forEach(function(u){imgs.push([u,x[0]])})});
  var tiles=imgs.length?imgs.slice(0,8).map(function(q){return '<div class="ph" style="background:#050605 url('+esc(q[0])+') center/cover"><b style="text-shadow:1px 1px 2px #000">'+esc(q[1])+'</b></div>'}).join(""):d.it.map(function(x){return '<div class="ph"><span class="glow" style="width:56px"><span class="lg"></span></span><span>Foto con modelo</span><b>'+esc(x[0])+'</b></div>'}).join("");
  return RZ+'<div class="tb"><span class="lg ico" aria-hidden="true"></span><div class="t">Ego - '+esc(d.n)+'</div><div class="ctl"><button class="wMin" aria-label="Minimizar">_</button><button class="wMax" aria-label="Maximizar">&#9633;</button><button class="wCls x" aria-label="Cerrar">x</button></div></div>'
  +'<div class="addr"><b>Dirección</b><span>ego://drops/'+slug+'</span></div>'
  +'<div class="scroll"><div class="fb"><div class="pane"><div class="dfi"><span class="fi"></span></div><b>'+esc(d.n)+'</b><div class="pl">Prendas: '+d.it.length+'</div><div class="pl">Fotos: '+d.it.length+'</div></div>'
  +'<div class="fc"><section><h2>Sobre este drop</h2><div class="panel"><p style="margin:0">'+esc(d.d)+'</p></div></section>'
  +'<section><h2>Prendas</h2><div class="panel" style="padding:0 12px">'+rows+'</div></section>'
  +'<section><h2>Fotos con modelos</h2><div class="panel"><div class="phg">'+tiles+'</div></div></section></div></div></div>';
}
function openDrop(i){
  if(dw[i]){dw[i].open();return}
  var d=DROPS[i],el=document.createElement("div"),n=Object.keys(dw).length,vw=window.innerWidth,vh=window.innerHeight-38;
  el.className="win fw";el.innerHTML=dropHTML(d,slug(d.n));document.body.appendChild(el);
  var task=document.createElement("button");task.className="task";task.textContent=d.n;barEl.insertBefore(task,trayEl);
  dw[i]=makeWin(el,task,{x:Math.max(0,Math.min(150+n*30,vw-420)),y:Math.min(30+n*30,Math.max(0,vh-300)),w:Math.min(680,vw-40),h:Math.min(540,vh-50)});
  dw[i].open();
}
DROPS.forEach(function(d,i){
  var b=document.createElement("button"),pt=d.n.split(" - ");
  b.className="dicon";b.innerHTML='<span class="dfi"><span class="fi"></span></span><span>'+esc(pt[0])+(pt[1]?'<br>'+esc(pt[1]):'')+'</span>';
  b._open=function(){openDrop(i)};$("icons").appendChild(b);
});
var selEl=document.createElement("div"),selS=null;
selEl.className="sel hide";document.body.appendChild(selEl);
function selIcons(clear){Array.prototype.forEach.call(document.querySelectorAll(".dicon"),function(b){b.classList.remove("sel-on")})}
document.addEventListener("pointerdown",function(e){
  var t=e.target;
  if(!(t===document.body||t===document.documentElement||(t.classList&&t.classList.contains("icons")))||e.button>0)return;
  selS={x:e.clientX,y:e.clientY,on:false};selIcons();e.preventDefault();
});
window.addEventListener("pointermove",function(e){
  if(!selS)return;
  var x1=Math.min(selS.x,e.clientX),y1=Math.min(selS.y,e.clientY),x2=Math.max(selS.x,e.clientX),y2=Math.max(selS.y,e.clientY);
  if(!selS.on&&(x2-x1<4&&y2-y1<4))return;
  selS.on=true;selEl.classList.remove("hide");
  selEl.style.left=x1+"px";selEl.style.top=y1+"px";selEl.style.width=(x2-x1)+"px";selEl.style.height=(y2-y1)+"px";
  Array.prototype.forEach.call(document.querySelectorAll(".dicon"),function(b){
    var r=b.getBoundingClientRect(),hit=r.right>x1&&r.left<x2&&r.bottom>y1&&r.top<y2;
    b.classList.toggle("sel-on",hit);
  });
});
function endSel(){selS=null;selEl.classList.add("hide")}
window.addEventListener("pointerup",endSel);window.addEventListener("pointercancel",endSel);
var lockW=null,lockOpen=false,LOCKPW="ego2026";
function lockSVG(o){var sh=o?'<rect x="2" y="-1" width="2" height="4"/><rect x="2" y="-1" width="6" height="1"/>':'<rect x="3" y="0" width="6" height="1"/><rect x="2" y="1" width="2" height="4"/><rect x="8" y="1" width="2" height="4"/>';return '<svg viewBox="0 -2 12 16" aria-hidden="true"><g fill="#efe9dc">'+sh+'<rect x="0" y="5" width="12" height="8"/></g><g fill="#050605"><rect x="5" y="7" width="2" height="2"/><rect x="5" y="9" width="2" height="2"/></g></svg>'}
var LK_LOCKED='<div class="pr">PON LA CONTRASEÑA_</div><label for="lkPw" style="position:absolute;left:-9999px">Contraseña</label><input id="lkPw" type="password" autocomplete="off"><div class="row"><button class="p" id="lkGo">Entrar</button></div><p class="msg" id="lkMsg" role="alert"></p>';
var LK_OPEN='<div class="pr">ACCESO CONCEDIDO</div><p style="margin:0;color:var(--mute)">Zona privada de Ego. Aquí irá el contenido exclusivo.</p>';
function setLockIcon(){var l=document.querySelector("#lockIcon .di2 svg");if(l)l.outerHTML=lockSVG(lockOpen)}
function lkCheck(){
  var f=$("lkPw");
  if(f.value===LOCKPW){lockOpen=true;$("lkBody").innerHTML=LK_OPEN;setLockIcon()}
  else{msg("lkMsg","Contraseña incorrecta.");f.classList.remove("shake");void f.offsetWidth;f.classList.add("shake");f.value="";f.focus()}
}
function lockHTML(){
  var z="",i;for(i=0;i<9;i++)z+='<i style="transform:translateZ('+(i*2-8)+'px);filter:brightness('+(0.35+i*0.08).toFixed(2)+')"></i>';
  return RZ+'<div class="tb"><span class="lg ico" aria-hidden="true"></span><div class="t">Ego - ego.lock</div><div class="ctl"><button class="wMin" aria-label="Minimizar">_</button><button class="wMax" aria-label="Maximizar">&#9633;</button><button class="wCls x" aria-label="Cerrar">x</button></div></div>'
  +'<div class="addr"><b>Dirección</b><span>ego://privado</span></div>'
  +'<div class="scroll"><div class="lockbox"><div class="stage" aria-hidden="true"><div class="spin">'+z+'</div></div><div class="hint">Arrastra el logo para girarlo</div><div id="lkBody">'+LK_LOCKED+'</div></div></div>';
}
function lkInit(el){
  var st=el.querySelector(".stage"),sp=el.querySelector(".spin"),S={rx:-8,ry:-20,vy:0,d:null,t:0},reduce=window.matchMedia("(prefers-reduced-motion:reduce)").matches;
  function paint(){sp.style.transform="rotateX("+S.rx+"deg) rotateY("+S.ry+"deg)"}
  st.addEventListener("pointerdown",function(e){S.d={x:e.clientX,y:e.clientY,t:performance.now()};S.vy=0;st.setPointerCapture(e.pointerId);e.preventDefault()});
  st.addEventListener("pointermove",function(e){
    if(!S.d)return;
    var now=performance.now(),dx=e.clientX-S.d.x,dy=e.clientY-S.d.y,dt=Math.max(1,now-S.d.t)/1000;
    S.ry+=dx*0.6;S.rx=Math.max(-85,Math.min(85,S.rx-dy*0.6));
    S.vy=Math.max(-900,Math.min(900,dx*0.6/dt));S.d={x:e.clientX,y:e.clientY,t:now};paint();
  });
  function up(){if(S.d&&performance.now()-S.d.t>80)S.vy=0;S.d=null}
  st.addEventListener("pointerup",up);st.addEventListener("pointercancel",up);
  st.addEventListener("dblclick",function(){S.rx=-8;paint()});
  function tick(t){
    var dt=Math.min(0.05,(t-(S.t||t))/1000);S.t=t;
    if(!S.d&&!el.classList.contains("min")&&!el.classList.contains("closed")){S.ry+=((reduce?0:22.5)+S.vy)*dt;S.vy*=Math.exp(-2.5*dt);paint()}
    requestAnimationFrame(tick);
  }
  paint();requestAnimationFrame(tick);
}
function openLock(){
  lockOpen=false;
  if(lockW){$("lkBody").innerHTML=LK_LOCKED;setLockIcon();lockW.open();$("lkPw").focus();return}
  var el=document.createElement("div"),vw=window.innerWidth,vh=window.innerHeight-38;
  el.className="win fw";el.innerHTML=lockHTML();document.body.appendChild(el);lkInit(el);
  var task=document.createElement("button");task.className="task";task.textContent="ego.lock";barEl.insertBefore(task,trayEl);
  lockW=makeWin(el,task,{x:Math.max(0,vw-440-130),y:Math.min(30,Math.max(0,vh-300)),w:Math.min(440,vw-40),h:Math.min(560,vh-50)});
  el.addEventListener("click",function(e){if(e.target.closest("#lkGo"))lkCheck()});
  el.addEventListener("keydown",function(e){if(e.key=="Enter"&&e.target.id=="lkPw")lkCheck()});
  lockW.open();$("lkPw").focus();
}
(function(){
  var b=document.createElement("button");b.className="dicon";b.id="lockIcon";
  b.innerHTML='<span class="di2"><span class="px"></span>'+lockSVG(false)+'</span><span>ego.lock</span>';
  b._open=openLock;$("icons2").appendChild(b);
})();
function mineSVG(){
  var r="",x,y,dx,dy,b;
  for(y=0;y<13;y++)for(x=0;x<13;x++){dx=x-6;dy=y-6;b=dx*dx+dy*dy<=17||dx==0||dy==0||(Math.abs(dx)==Math.abs(dy)&&Math.abs(dx)>=3&&Math.abs(dx)<=5);if(b)r+='<rect x="'+x+'" y="'+y+'" width="1" height="1"/>'}
  return '<svg viewBox="0 0 13 13" aria-hidden="true"><g fill="#efe9dc">'+r+'</g><rect x="4" y="4" width="2" height="2" fill="#050605"/></svg>';
}
var MS={r:9,c:9,m:10,cells:[],started:false,over:false,won:false,flags:0,time:0,rev:0,timer:0,boom:-1,face:":)"},msW=null,msLp=false,msLt=0;
function lcd(n){n=Math.max(-99,Math.min(999,n));return n<0?"-"+("0"+(-n)).slice(-2):("00"+n).slice(-3)}
function msNb(i){var r=Math.floor(i/MS.c),c=i%MS.c,o=[],a,b;for(a=-1;a<=1;a++)for(b=-1;b<=1;b++){if(!a&&!b)continue;var y=r+a,x=c+b;if(y>=0&&y<MS.r&&x>=0&&x<MS.c)o.push(y*MS.c+x)}return o}
function msNew(){
  var i;clearInterval(MS.timer);MS.cells=[];
  for(i=0;i<MS.r*MS.c;i++)MS.cells.push({m:false,n:0,o:false,f:false,w:false});
  MS.started=false;MS.over=false;MS.won=false;MS.flags=0;MS.time=0;MS.rev=0;MS.boom=-1;MS.face=":)";
  msRender("Clic para abrir. Clic derecho o mantener pulsado para bandera.");
}
function msPlace(safe){
  var idx=[],i,j,t;
  for(i=0;i<MS.cells.length;i++)if(i!=safe)idx.push(i);
  for(i=idx.length-1;i>0;i--){j=Math.floor(Math.random()*(i+1));t=idx[i];idx[i]=idx[j];idx[j]=t}
  for(i=0;i<MS.m;i++)MS.cells[idx[i]].m=true;
  for(i=0;i<MS.cells.length;i++)MS.cells[i].n=msNb(i).filter(function(k){return MS.cells[k].m}).length;
}
function msOpen(i){
  var c=MS.cells[i];
  if(MS.over||c.o||c.f)return;
  if(!MS.started){msPlace(i);MS.started=true;MS.timer=setInterval(function(){MS.time++;var e=$("msT");if(e)e.textContent=lcd(MS.time)},1000)}
  if(c.m){
    MS.over=true;MS.boom=i;MS.face=":(";clearInterval(MS.timer);
    MS.cells.forEach(function(k){if(k.m&&!k.f)k.o=true;if(k.f&&!k.m)k.w=true});
    return msRender("Perdiste. Pulsa la carita para jugar otra vez.");
  }
  var st=[i];
  while(st.length){
    var j=st.pop(),k=MS.cells[j];
    if(k.o||k.f)continue;
    k.o=true;MS.rev++;
    if(k.n===0)msNb(j).forEach(function(q){if(!MS.cells[q].o&&!MS.cells[q].f)st.push(q)});
  }
  if(MS.rev===MS.cells.length-MS.m){
    MS.over=true;MS.won=true;MS.face="B)";clearInterval(MS.timer);
    MS.cells.forEach(function(k){if(k.m)k.f=true});MS.flags=MS.m;
    return msRender("Ganaste en "+MS.time+" segundos. Pulsa la carita para jugar otra vez.");
  }
  msRender("");
}
function msFlag(i){
  var c=MS.cells[i];if(MS.over||c.o)return;
  c.f=!c.f;MS.flags+=c.f?1:-1;msRender("");
}
function msChord(i){
  var c=MS.cells[i];if(MS.over||!c.o||!c.n)return;
  var nb=msNb(i);
  if(nb.filter(function(k){return MS.cells[k].f}).length!==c.n)return;
  nb.forEach(function(k){msOpen(k)});
}
function msRender(note){
  var b=$("msB");if(!b)return;
  var ai=document.activeElement&&document.activeElement.getAttribute?document.activeElement.getAttribute("data-i"):null,h="",i,c,cl,t,lab;
  for(i=0;i<MS.cells.length;i++){
    c=MS.cells[i];cl="mc";t="";lab="Sin abrir";
    if(c.o){cl+=" o";if(c.m){t=mineSVG();lab="Mina";if(i===MS.boom)cl+=" x"}else if(c.n){cl+=" n"+c.n;t=c.n;lab=c.n+" minas cerca"}else lab="Vacía"}
    else if(c.f){cl+=" fl";t=c.w?"x":"F";lab=c.w?"Bandera incorrecta":"Bandera"}
    h+='<button class="'+cl+'" data-i="'+i+'" aria-label="'+lab+', fila '+(Math.floor(i/MS.c)+1)+', columna '+(i%MS.c+1)+'">'+t+'</button>';
  }
  b.innerHTML=h;
  $("msM").textContent=lcd(MS.m-MS.flags);$("msT").textContent=lcd(MS.time);$("msF").textContent=MS.face;
  if(note!==""&&note!==undefined)$("msS").textContent=note;
  if(ai!==null){var f=b.querySelector('[data-i="'+ai+'"]');if(f)f.focus()}
}
function msHTML(){
  return RZ+'<div class="tb"><span class="lg ico" aria-hidden="true"></span><div class="t">Ego - Minesweeper</div><div class="ctl"><button class="wMin" aria-label="Minimizar">_</button><button class="wMax" aria-label="Maximizar">&#9633;</button><button class="wCls x" aria-label="Cerrar">x</button></div></div>'
  +'<div class="scroll"><div class="ms"><div class="mshead"><div class="lcd" id="msM" role="img" aria-label="Minas restantes">010</div><button class="face" id="msF" aria-label="Nuevo juego">:)</button><div class="lcd" id="msT" role="img" aria-label="Tiempo">000</div></div><div class="msb" id="msB"></div><div class="hint" id="msS" role="status" style="margin:0;text-align:center"></div></div></div>';
}
function openMS(){
  if(msW){msW.open();return}
  var el=document.createElement("div"),vw=window.innerWidth,vh=window.innerHeight-38;
  el.className="win fw";el.innerHTML=msHTML();document.body.appendChild(el);
  var task=document.createElement("button");task.className="task";task.textContent="Minesweeper";barEl.insertBefore(task,trayEl);
  msW=makeWin(el,task,{x:Math.max(0,vw-340-130),y:Math.max(0,vh-470),w:Math.min(340,vw-40),h:Math.min(470,vh-30)});
  el.addEventListener("click",function(e){
    if(e.target.closest("#msF")){msNew();return}
    var b=e.target.closest(".mc");if(!b)return;
    if(msLp){msLp=false;return}
    var i=+b.getAttribute("data-i");
    if(MS.cells[i].o)msChord(i);else msOpen(i);
  });
  el.addEventListener("contextmenu",function(e){
    var b=e.target.closest(".mc");if(!b)return;
    e.preventDefault();
    if(lastPT==="mouse")msFlag(+b.getAttribute("data-i"));
  });
  el.addEventListener("pointerdown",function(e){
    var b=e.target.closest(".mc");msLp=false;clearTimeout(msLt);
    if(!b||e.pointerType==="mouse")return;
    var i=+b.getAttribute("data-i");
    msLt=setTimeout(function(){msLp=true;msFlag(i)},420);
  });
  function stopLp(){clearTimeout(msLt)}
  el.addEventListener("pointerup",stopLp);el.addEventListener("pointercancel",stopLp);el.addEventListener("pointermove",function(e){if(e.pointerType!=="mouse"&&(Math.abs(e.movementX)>3||Math.abs(e.movementY)>3))stopLp()});
  el.addEventListener("keydown",function(e){
    var b=e.target.closest&&e.target.closest(".mc");
    if(b&&(e.key==="f"||e.key==="F")){e.preventDefault();msFlag(+b.getAttribute("data-i"))}
  });
  msNew();msW.open();
}
(function(){
  var b=document.createElement("button");b.className="dicon";b.id="msIcon";
  b.innerHTML='<span class="di3">'+mineSVG()+'</span><span>minesweeper.exe</span>';
  b._open=openMS;$("icons3").appendChild(b);
})();
var iconsEl=document,anchor=null,lastPT="mouse";
function allIcons(){return Array.prototype.slice.call(iconsEl.querySelectorAll(".dicon"))}
function selected(){return allIcons().filter(function(b){return b.classList.contains("sel-on")})}
function setSel(arr){allIcons().forEach(function(b){b.classList.toggle("sel-on",arr.indexOf(b)>=0)})}
function openSel(list){list.forEach(function(b){if(b._open)b._open()})}
document.addEventListener("pointerdown",function(e){lastPT=e.pointerType||"mouse"},true);
iconsEl.addEventListener("click",function(e){
  var b=e.target.closest(".dicon");if(!b)return;
  var all=allIcons(),i=all.indexOf(b);
  if(lastPT!="mouse"&&e.detail>0){setSel([b]);anchor=i;openSel([b]);return}
  if(e.shiftKey&&anchor!==null){var a=Math.min(anchor,i),z=Math.max(anchor,i);setSel(all.slice(a,z+1));return}
  if(e.ctrlKey||e.metaKey){b.classList.toggle("sel-on");anchor=i;return}
  setSel([b]);anchor=i;
});
iconsEl.addEventListener("dblclick",function(e){var b=e.target.closest(".dicon");if(!b||lastPT!="mouse")return;openSel([b])});
document.addEventListener("keydown",function(e){
  var t=e.target,tag=t.tagName,typing=tag=="INPUT"||tag=="TEXTAREA"||tag=="SELECT";
  if(typing||!$("ov").classList.contains("hide"))return;
  var desk=t===document.body||(t.classList&&t.classList.contains("dicon")),all=allIcons(),sel=selected();
  if(e.key=="Enter"&&desk){
    var list=sel.length?sel:(t.classList.contains("dicon")?[t]:[]);
    if(list.length){e.preventDefault();openSel(list)}
    return;
  }
  if((e.ctrlKey||e.metaKey)&&e.key.toLowerCase()=="a"&&desk){e.preventDefault();setSel(all);return}
  if(e.key=="Escape"&&sel.length){setSel([]);return}
  if(desk&&(e.key=="ArrowDown"||e.key=="ArrowUp"||e.key=="ArrowRight"||e.key=="ArrowLeft")){
    e.preventDefault();
    var cur=sel.length?all.indexOf(sel[sel.length-1]):-1,d=(e.key=="ArrowDown"||e.key=="ArrowRight")?1:-1,n=Math.min(all.length-1,Math.max(0,cur<0?(d>0?0:all.length-1):cur+d));
    if(e.shiftKey&&anchor!==null){var a=Math.min(anchor,n),z=Math.max(anchor,n);setSel(all.slice(a,z+1))}else{setSel([all[n]]);anchor=n}
    all[n].focus();
  }
});
(function(){
  var b=$("boot"),red=window.matchMedia("(prefers-reduced-motion:reduce)").matches,done=false;
  function go(){if(done)return;done=true;b.classList.add("out");setTimeout(function(){if(b.parentNode)b.parentNode.removeChild(b)},700)}
  setTimeout(go,red?1200:4200);
  b.addEventListener("click",go);
  document.addEventListener("keydown",go,{once:true});
})();
render();renderTabs();tick();setInterval(tick,30000);
